<template>
  <div class="slot-inspector-slot-table">
    <sp-table
      v-preserve-properties:columns="columns"
      v-preserve-properties:items="slots"
      class="slot-inspector-slot-table__table"
      row-key="key"
    ></sp-table>
  </div>
</template>

<script setup>
import { h } from "vue";
import { vPreserveProperties } from "#ce/utils/property-bindings";
import { t } from "#ce/apps/SpAdmin/SpSlotInspectorApp/i18n";
import SlotInspectorStatusTag from "./cells/SlotInspectorStatusTag.ce.vue";

const props = defineProps({
  /**
   * A visit-type group's slots, as the payload lists them.
   */
  slots: {
    type: Array,
    default: () => [],
  },
  /**
   * Copy for each reason a slot can carry, keyed by reason.
   */
  reasons: {
    type: Object,
    default: () => ({}),
  },
});

// A 1% column in auto layout shrinks to its content, so Reason takes the rest of the row.
const CONTENT_COLUMN_WIDTH = "1%";

// The time stays on one line in its shrunk column.
const NO_WRAP_STYLE = Object.freeze({ whiteSpace: "nowrap" });

const columns = [
  { field: "when", label: t("column_when"), width: CONTENT_COLUMN_WIDTH, formatter: renderWhen },
  { field: "action", label: t("column_action"), width: CONTENT_COLUMN_WIDTH, formatter: renderAction },
  { field: "reason", label: t("column_reason"), formatter: reasonCopy },
];

function renderWhen(when) {
  return h("span", { style: NO_WRAP_STYLE }, when);
}

function renderAction(action) {
  return h(SlotInspectorStatusTag, { action });
}

function reasonCopy(reason) {
  return reason ? props.reasons[reason] : "";
}
</script>

<style scoped lang="scss">
.slot-inspector-slot-table {
  padding-inline: var(--sp-ref-scale-16);
  padding-block-end: var(--sp-ref-scale-12);

  // Sits on the expanded row's stripe: no frame and no header fill of its own, and dividers dark enough to show on
  // the stripe.
  &__table {
    --sp-comp-table-frame-border-width: 0;
    --sp-comp-table-border-radius: 0;
    --sp-comp-table-border-color: var(--sp-sys-color-outline);
    --sp-comp-table-header-background-color: transparent;
    --sp-comp-table-cell-padding-block: var(--sp-ref-scale-8);
    --sp-comp-table-cell-padding-inline: var(--sp-ref-scale-16);

    font-weight: var(--sp-sys-font-weight-light);
  }
}
</style>
